// Libellé de statut traduit. La valeur backend (FR majuscule) reste inchangée
// pour la logique ; seul l'affichage est traduit via les clés st_*.
export const statusSlug = (s) =>
  (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "_").replace(/(^_|_$)/g, "");

export const statusLabel = (t, s) => {
  const key = `st_${statusSlug(s)}`;
  const val = t(key);
  return val === key ? s : val;
};

export const priorityLabel = (t, p) => {
  if (!p) return p;
  const key = `pr_${statusSlug(p)}`;
  const val = t(key);
  return val === key ? p : val;
};
